document.addEventListener('alpine:init', () => {
  Alpine.data('LoginDrawer', () => ({
    state: {
      open: false,
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      document.addEventListener('open:login-drawer', () => {
        this.openDrawer();
      });
    },
    openDrawer() {
      document.querySelectorAll('.drawer[open]').forEach((drawer) => {
        drawer.removeAttribute('open');
      });
      this.state.open = true;
    },
    closeDrawer() {
      this.state.open = false;
    },
  }));
});
